var _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMoMenuM01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 42,
    viewBox: "0 0 40 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0892 1V13.0496H15.5275V1H1V36.7902H38.6167V1H24.0892Z",
    fill: "white",
    stroke: "#D6D6D6",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0935 1H15.5271V13.0496H24.0935V1Z",
    fill: "white",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5396 37.3754C37.3703 38.206 37.3703 39.5465 36.5396 40.3772C35.7089 41.2078 34.3638 41.2078 33.5378 40.3772L24.6646 31.5039C23.8387 30.6733 23.8387 29.3281 24.6646 28.5022C25.4953 27.6715 26.8405 27.6715 27.6664 28.5022L36.5396 37.3754Z",
    fill: "white",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3623 18.6366C31.8789 22.152 31.8789 27.848 28.3623 31.3634C24.8456 34.8789 19.1476 34.8789 15.6355 31.3634C12.1235 27.848 12.1189 22.152 15.6355 18.6366C19.1522 15.1211 24.8502 15.1211 28.3623 18.6366Z",
    fill: "white",
    stroke: "#245FF8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2414 20.7577C28.5859 23.1013 28.5859 26.8987 26.2414 29.2423C23.897 31.5859 20.0983 31.5859 17.7569 29.2423C15.4156 26.8987 15.4125 23.1013 17.7569 20.7577C20.1014 18.4141 23.9 18.4141 26.2414 20.7577Z",
    fill: "white",
    stroke: "#245FF8",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMoMenuM01);
export default __webpack_public_path__ + "static/media/ic_mo_menu_m01.774daa4304d64f8c7d312d93c1375478.svg";
export { ForwardRef as ReactComponent };